// extracted by mini-css-extract-plugin
module.exports = {"drop-zone":"ImageDropZone_drop-zone__3WFVW","bold":"ImageDropZone_bold__UUJkf"};